import styled, { keyframes } from 'styled-components';
import { darken } from 'polished';

export const Wrapper = styled.div`
  height: 100%;
  background: var(--white);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  max-width: 350px;
  text-align: center;
  padding: 35px 50px;
  border: 1px solid var(--gray);
  border-radius: 5%;
  margin: auto;

  img {
    background: var(--white);
    width: 100px;
  }

  form {
    display: flex;
    flex-direction: column;
    align-items: center;

    h2 {
      color: var(--blueDark);
      padding: 30px 0;
    }

    > div {
      text-align: center;
      padding: 5px 0;
      font-size: 14px;
      font-weight: bold;
    }

    input {
      width: 80%;
      border: 1px solid var(--gray);
      border-radius: 10px;
      height: 50px;
      padding: 0 15px;
      margin: 10px 0 10px 0;
      color: var(--black);

      &::placeholder {
        color: var(--gray);
      }
    }

    span {
      color: var(--salmon);
      align-self: center;
      margin: 0 0 10px;
      font-weight: bold;
      font-size: 14px;
    }

    button {
      margin: 20px 0 30px 0;
      height: 34px;
      background: var(--yellowDark);
      width: 40%;
      color: #1c2156;
      border: 0;
      border-radius: 10px;
      font-size: 17px;
      font-weight: bold;
      transition: background 0.2s;
      box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.75);

      &:hover {
        background: ${darken(0.06, '#f7c325')};
      }
    }

    a {
      color: var(--white);
      margin-top: 15px;
      font-size: 16px;
      opacity: 0.8;

      &:hover {
        opacity: 1;
      }
    }
  }
`;
const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export const Loader = styled.div`
  border: 0.2em solid rgba(0, 0, 0, 0.1);
  border-top: 0.2em solid var(--grayLight);
  border-radius: 50%;
  width: 2.28571429rem;
  height: 2.28571429rem;
  animation: ${spin} 0.6s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  display: ${props => props.visible};
`;
